import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=37c8d5ba&scoped=true&"
import script from "./questionnaire.vue?vue&type=script&lang=js&"
export * from "./questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire.vue?vue&type=style&index=0&id=37c8d5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c8d5ba",
  null
  
)

export default component.exports